export default [{
  "id": "nepean-h",
  "items": [{
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "13 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac8-e095-4361-b878-e2ab1609c968",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4888",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "22 Aug 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6893-417b-919a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5000',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "25 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c524-42af-a2c4-79246eb8d117",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "nepean-h"
    }
  ]
}, {
  "id": "therock-c",
  "items": [{
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "14 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac8-e095-4361-b778-e2ab1609c968",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Aug 2020",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6893-417b-912a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '2045',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "30 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c324-42af-a2c4-79246eb8d117",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "therock-c"
    }
  ]
}, {
  "id": "easterncrk-p",
  "items": [{
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "12 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac8-e095-4361-b878-e2abd609c968",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "8886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Sep 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6893-417b-219a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5098',
        "fileType": 'JPG',
        "type": null
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "1 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c524-42df-a2c4-79246eb8d117",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "easterncrk-p"
    }
  ]
},{
  "id": "nepean-h",
  "items": [{
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "13 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac8-e095-4361-b878-e2as1609c968",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4888",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "22 Aug 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6893-417b-919a-33c84150f276",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5000',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "25 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943f4e-c524-42af-a2c4-79246eb8d117",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "nepean-h"
    }
  ]
}, {
  "id": "therock-c",
  "items": [{
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "14 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac8-e095-4361-b778-e2ab1609c966",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Aug 2020",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6493-417b-912a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '2045',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "30 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c324-42af-a2c4-79236eb8d117",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "therock-c"
    }
  ]
}, {
  "id": "easterncrk-p",
  "items": [{
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "12 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
      "id": "792degc8-e095-4361-b878-e2abd609c968",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "8886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Sep 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af15837-6893-417b-219a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5098',
        "fileType": 'JPG',
        "type": null
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "1 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c524-42dg-a2c4-79246eb8d117",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "easterncrk-p"
    }
  ]
},{
  "id": "nepean-h",
  "items": [{
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "13 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac8-e095-4361-b878-e2ab1509c968",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4888",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "22 Aug 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6893-417b-919a-33c84157f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5000',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "25 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c624-42af-a2c4-79246eb8d117",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "nepean-h"
    }
  ]
}, {
  "id": "therock-c",
  "items": [{
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "14 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac8-e095-4361-b778-e2ag1609c968",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Aug 2020",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af14837-6893-417b-912a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '2045',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "30 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c324-42gf-a2c4-79246eb8d117",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "therock-c"
    }
  ]
}, {
  "id": "easterncrk-p",
  "items": [{
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "12 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
      "id": "791deac8-e095-4361-b878-e2abd609c968",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "8886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Sep 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6853-417b-219a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5098',
        "fileType": 'JPG',
        "type": null
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "1 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c524-42df-a2c4-79246eb8h117",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "easterncrk-p"
    }
  ]
},{
  "id": "nepean-h",
  "items": [{
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "13 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac5-e095-4361-b878-e2ab1609c968",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4888",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "22 Aug 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6893-417b-919a-33c84150f775",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5000',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "25 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c524-42af-a2g4-79246eb8d117",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "nepean-h"
    }
  ]
}, {
  "id": "therock-c",
  "items": [{
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "14 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
      "id": "792deaf8-e095-4361-b778-e2ab1609c968",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Aug 2020",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6893-417b-912a-33c84750f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '2045',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "30 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84743d4e-c324-42af-a2c4-79246eb8d117",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "therock-c"
    }
  ]
}, {
  "id": "easterncrk-p",
  "items": [{
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "12 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac8-e095-4361-b878-e2abd606c968",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "8886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Sep 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af19837-6893-417b-219a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5098',
        "fileType": 'JPG',
        "type": null
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "1 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c524-42df-a2c4-79246kb8d117",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "easterncrk-p"
    }
  ]
},{
  "id": "nepean-h",
  "items": [{
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "13 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
      "id": "793deac8-e095-4361-b878-e2ab1609c968",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4888",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "22 Aug 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4df13837-6893-417b-919a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5000',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "nepean-h"
    },
    {
      "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/nepean-h/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "25 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c524-42af-a2c4-79646eb8d117",
      "file": {
        "filePath": "https://nepean-h-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/nepean-h/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "nepean-h"
    }
  ]
}, {
  "id": "therock-c",
  "items": [{
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "14 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
      "id": "792dejc8-e095-4361-b778-e2ab1609c968",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "4886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Aug 2020",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af19837-6893-417b-912a-33c84150f776",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '2045',
        "fileType": 'PDF',
        "type": null
      },
      "domain": "therock-c"
    },
    {
      "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://therock-c-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/therock-c/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "30 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c324-42af-a2c4-79246eb8d116",
      "file": {
        "filePath": "https://therock-c-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/therock-c/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "therock-c"
    }
  ]
}, {
  "id": "easterncrk-p",
  "items": [{
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/10/newsletter---complex.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "12 Oct 2019",
      "description": "A dummy newsletter.",
      "title": "Newsletter - complex",
      "image": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
      "id": "792deac8-e095-4361-b878-e2hbd609c968",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/Liverpool-Girls-High-School_Logo.png",
        "link": null,
        "fileSize": "8886",
        "fileType": "PNG",
        "type": "file"
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/test0.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "20 Sep 2019",
      "description": null,
      "title": "test",
      "image": null,
      "id": "4af13837-6893-417b-219a-33c84150f976",
      "file": {
        "filePath": null,
        "link": null,
        "fileSize": '5098',
        "fileType": 'JPG',
        "type": null
      },
      "domain": "easterncrk-p"
    },
    {
      "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www/newsletter/2019/8/last-newsletter.html",
      "publisher": {
        "url": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/doe/sws/schools/l/easterncrk-p/www.html",
        "name": "Liverpool Girls High School1"
      },
      "lastModified": "Tue, 15 Oct 2019 15:14:21 AEDT",
      "date": "1 Aug 2019",
      "description": null,
      "title": "last newsletter",
      "image": null,
      "id": "84943d4e-c544-42df-a2c4-79246eb8d117",
      "file": {
        "filePath": "https://easterncrk-p-nswdoe-dev65.adobecqms.net/content/dam/doe/sws/schools/l/easterncrk-p/newsletter/2019/8/sample4.PDF",
        "link": "https://www.google.com",
        "fileSize": "3031",
        "fileType": "PDF",
        "type": "file"
      },
      "domain": "easterncrk-p"
    }
  ]
}]
